export default {"src":"/_next/static/media/man.dcedcfee.svg","height":553,"width":595};